import React from 'react';
import { Dialog, DialogContent, useMediaQuery, Box } from '@mui/material';

function GeneralModal({
  component: Component,
  componentProps = {},
  setOpen,
  open,
  handleClose,
  wdth = '600px',
  maxHeight = '80vh',
  noPadding = false,
  fullWidth = false,
}) {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={fullWidth || isMobile}
      maxWidth={false} // usamos false para controlar manualmente el ancho con sx
      PaperProps={{
        sx: {
          width: isMobile ? '95%' : wdth,
          maxHeight,
          borderRadius: 3,
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: 6,
          bgcolor: 'background.paper',
        },
      }}
    >
      <DialogContent
        dividers
        sx={{
          ...(noPadding ? { p: 0 } : { p: 4 }),
          flex: 1,
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Component {...componentProps} setOpen={setOpen} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default GeneralModal;
